import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { requestUserAndPatient } from 'connect/actions';
import { selectDataUserAuthenticated } from 'connect/selectors';

import GoogleOneTapService from './GoogleOneTapService';

export const useGoogleOneTap = (): void => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectDataUserAuthenticated);
  const location = useLocation();

  const isPathAllowed = useMemo(() => {
    // Only show Google One Tap on specific allowed paths
    const googleOneTapAllowedPaths = [
      '/results',
    ];

    return googleOneTapAllowedPaths.some((path) => location.pathname.startsWith(path));
  }, [location.pathname]);

  useEffect(() => {
    if (!isPathAllowed || isAuthenticated) {
      return;
    }

    // Set up callback to update Redux store when authentication succeeds
    GoogleOneTapService.setAuthenticationSuccessCallback(() => {
      dispatch(requestUserAndPatient());
    });

    GoogleOneTapService.initialize();
  }, [dispatch, isAuthenticated, isPathAllowed]);
};
